export default "__VITE_ASSET__CPMK6QE0__"